import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

const SkeletonCard = () => (
  <div className="rounded-lg shadow-md overflow-hidden animate-pulse">
    <div className="aspect-square bg-gray-200" />
    <div className="p-4 space-y-2">
      <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto" />
      <div className="h-3 bg-gray-200 rounded w-full" />
      <div className="h-9 bg-gray-200 rounded w-full mt-4" />
    </div>
  </div>
);

const PanaderiaSection = ({ panaderia, openLightbox, openProductDetail, getImageUrl, loadingProducts }) => {
  return (
    <section id="panaderia" className="py-20 px-6 bg-gradient-to-b from-amber-50 to-cream">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-chocolate mb-4">🥐 Panadería</h2>
          <p className="text-lg text-chocolate-light max-w-2xl mx-auto">
            Deliciosos productos de panadería artesanal, perfectos para cualquier ocasión
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-8">
          {loadingProducts && panaderia.length === 0
            ? Array.from({ length: 4 }).map((_, i) => <SkeletonCard key={i} />)
            : panaderia.map((item) => (
            <Card key={item.id} className="border-0 shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group h-full flex flex-col">
              <div 
                className="aspect-square overflow-hidden cursor-pointer relative"
                onClick={() => openLightbox(getImageUrl(item.image), item.name)}
              >
                <img 
                  src={getImageUrl(item.image)} 
                  alt={`${item.name} – Brazolovers, Quito`}
                  loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
                  <span className="bg-white/90 text-chocolate px-3 py-1 rounded-full text-sm font-medium">
                    🔍 Ver imagen
                  </span>
                </div>
              </div>
              <CardContent className="p-4 flex flex-col flex-1">
                <div className="flex-grow space-y-2">
                  <h3 className="text-lg font-bold text-chocolate text-center">{item.name}</h3>
                  <p className="text-xs text-chocolate-light text-center line-clamp-2">{item.description}</p>
                </div>
                <div className="text-center mt-3">
                  {item.hasOption && <span className="text-xs text-chocolate-light">desde </span>}
                  <span className="text-2xl font-bold text-caramel">${item.price.toFixed(2)}</span>
                </div>
                <Button
                  onClick={() => openProductDetail(item, 'panaderia')}
                  className="w-full bg-[#d4a574] hover:bg-[#c49564] text-white transition-colors duration-200 mt-3"
                >
                  {item.hasOption && item.options && item.options.length > 0 ? 'Ver Opciones' : 'Agregar al Pedido'}
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        
        <p className="text-center text-sm text-amber-700 bg-amber-50 inline-block px-4 py-2 rounded-full mx-auto block w-fit">
          ⚠️ Sabores sujeto a disponibilidad
        </p>
      </div>
    </section>
  );
};

export default PanaderiaSection;
